export default {
      id: "clock-usage",
      viewBox: "0 0 21 21",
      url: "/dist/svg/" + "sprite.svg#clock-usage",
      toString: function () {
        return this.url;
      }
    }